var map = {
	"./baskast Kopie 2.jpg": 48,
	"./baskast Kopie 4.jpg": 49,
	"./baskast Kopie.jpg": 50,
	"./baskast.jpg": 51,
	"./baskast_.jpg": 52,
	"./baskast_mob.jpg": 53,
	"./buch.png": 54,
	"./buch_2.png": 55,
	"./readme.md": 56,
	"./rezept_1.jpg": 57,
	"./rezept_1.mdx": 58,
	"./rezept_1_do.mdx": 59,
	"./rezept_2.jpg": 60,
	"./rezept_2.mdx": 61,
	"./rezept_3.jpg": 62,
	"./rezept_3.mdx": 63,
	"./rezept_4.jpg": 64,
	"./rezept_4.mdx": 65,
	"./text_p1.mdx": 66,
	"./text_p2.mdx": 67,
	"./text_p3.mdx": 68,
	"./text_p4.mdx": 69,
	"./text_p5.mdx": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;